<div class="mt-1">
  <a
    href="http://www.clubinter.org.pe/tyc/content/pagos-en-linea"
    target="_blank"
  >Términos y condiciones</a
  >
  de uso del sistema de pagos del Club Internacional Arequipa
</div>
